import { Button } from "@timeedit/ui-components";
import ArrowLeftOutlined from "@timeedit/ui-components/icons/ArrowLeftOutlined";

interface BackButtonProps {
  handleGoBack: () => void;
}

export function BackButton({
  handleGoBack,
}: BackButtonProps): React.JSX.Element {
  return (
    <Button
      className="groupPage__button"
      type="text"
      icon={<ArrowLeftOutlined alt="Back" />}
      onClick={handleGoBack}
    />
  );
}
